export const OPENING_STATUS = {
  DRAFT: { label: 'Nháp', className: 'draft' },
  VALIDATED: { label: 'Đã kiểm tra', className: 'validated' },
  POSTED: { label: 'Đã ghi nhận', className: 'posted' },
  LOCKED: { label: 'Đã khóa', className: 'locked' },
  AGGREGATE: { label: 'Tổng hợp toàn công ty', className: 'aggregate' },
};

export const COMPANY_VIEW_MODE = {
  AGGREGATE: 'aggregate',
  COMPANY_SCOPE: 'company_scope',
};

export const COMPANY_VIEW_OPTIONS = [
  { value: COMPANY_VIEW_MODE.AGGREGATE, label: 'Tổng hợp toàn công ty' },
  { value: COMPANY_VIEW_MODE.COMPANY_SCOPE, label: 'Dữ liệu cấp công ty' },
];

export const OPENING_PERMISSION = {
  VIEW: 'AC_OPENING_BALANCE_VIEW',
  ADD: 'AC_OPENING_BALANCE_ADD',
  EDIT: 'AC_OPENING_BALANCE_EDIT',
  DELETE: 'AC_OPENING_BALANCE_DEL',
  IMPORT: 'AC_OPENING_BALANCE_IMPORT',
  EXPORT: 'AC_OPENING_BALANCE_EXPORT',
  VALIDATE: 'AC_OPENING_BALANCE_VALIDATE',
  POST: 'AC_OPENING_BALANCE_POST',
  LOCK: 'AC_OPENING_BALANCE_LOCK',
  UNLOCK: 'AC_OPENING_BALANCE_UNLOCK',
  ROLLBACK: 'AC_OPENING_BALANCE_ROLLBACK',
  HISTORY: 'AC_OPENING_BALANCE_HISTORY',
};

export const DATA_TYPE = {
  ACCOUNT: 'account',
  BANK: 'bank',
  CUSTOMER: 'customer',
  CUSTOMER_INVOICE: 'customer_invoice',
  SUPPLIER: 'supplier',
  SUPPLIER_INVOICE: 'supplier_invoice',
  EMPLOYEE: 'employee',
  INVENTORY: 'inventory',
};

export const TABS = [
  { key: DATA_TYPE.ACCOUNT, label: 'Số dư tài khoản', icon: 'fi fi-rr-list-tree' },
  { key: DATA_TYPE.BANK, label: 'Số dư TK ngân hàng', icon: 'fi fi-rr-bank' },
  { key: DATA_TYPE.CUSTOMER, label: 'Công nợ khách hàng', icon: 'fi fi-rr-user-time' },
  { key: DATA_TYPE.SUPPLIER, label: 'Công nợ nhà cung cấp', icon: 'fi fi-rr-truck-loading' },
  { key: DATA_TYPE.EMPLOYEE, label: 'Công nợ nhân viên', icon: 'fi fi-rr-users' },
  { key: DATA_TYPE.INVENTORY, label: 'Tồn kho vật tư, hàng hóa', icon: 'fi fi-rr-boxes' },
];

export const IMPORT_DATA_TYPES = [
  ...TABS.map((item) => ({ value: item.key, label: item.label })),
  { value: DATA_TYPE.CUSTOMER_INVOICE, label: 'Hóa đơn/công nợ khách hàng đầu kỳ' },
  { value: DATA_TYPE.SUPPLIER_INVOICE, label: 'Hóa đơn/công nợ nhà cung cấp đầu kỳ' },
];

export const IMPORT_MODES = [
  { value: 'INSERT', label: 'Thêm mới' },
  { value: 'UPSERT', label: 'Cập nhật dữ liệu trùng' },
  { value: 'REPLACE', label: 'Thay thế toàn bộ dữ liệu của tab' },
  { value: 'VALIDATE_ONLY', label: 'Chỉ kiểm tra, chưa ghi nhận' },
];

export const money = (value) =>
  new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2 }).format(Number(value || 0));

export const dateText = (value) => {
  if (!value) return '';
  const [year, month, day] = String(value).slice(0, 10).split('-');
  return day && month && year ? `${day}/${month}/${year}` : value;
};

export const businessScopeText = (row = {}) =>
  row.business_name || (row.business_id ? `Chi nhánh #${row.business_id}` : 'Cấp công ty');

export const storeScopeText = (row = {}) =>
  row.store_name || (row.store_id ? `Cửa hàng #${row.store_id}` : row.business_id ? 'Toàn chi nhánh' : 'Toàn công ty');

const textColumn = (title, dataIndex, width = 150) => ({ title, dataIndex, key: dataIndex, width });
const moneyColumn = (title, dataIndex, precision = 4) => ({
  title,
  dataIndex,
  key: dataIndex,
  width: 150,
  align: 'right',
  render: (value) => new Intl.NumberFormat('vi-VN', { maximumFractionDigits: precision }).format(Number(value || 0)),
  sorter: (a, b) => Number(a[dataIndex] || 0) - Number(b[dataIndex] || 0),
});

export const columnsFor = (dataType, { showScope = false } = {}) => {
  const debitCredit = [moneyColumn('Dư Nợ', 'debit'), moneyColumn('Dư Có', 'credit')];
  const scopeColumns = showScope
    ? [
        {
          ...textColumn('Chi nhánh', 'business_name', 220),
          render: (_, row) => businessScopeText(row),
        },
        {
          ...textColumn('Cửa hàng', 'store_name', 220),
          render: (_, row) => storeScopeText(row),
        },
      ]
    : [];
  const common = [
    textColumn('Loại tiền', 'currency_code', 100),
    moneyColumn('Tỷ giá', 'exchange_rate', 6),
    textColumn('Ghi chú', 'note', 220),
  ];
  if (dataType === DATA_TYPE.ACCOUNT) {
    return [
      textColumn('Số tài khoản', 'account_code', 160),
      textColumn('Tên tài khoản', 'account_name', 300),
      ...debitCredit,
      ...common,
    ];
  }
  if (dataType === DATA_TYPE.BANK) {
    return [
      ...scopeColumns,
      textColumn('Số TK ngân hàng', 'bank_number', 190),
      textColumn('Tên ngân hàng', 'bank_name', 260),
      textColumn('Số tài khoản kế toán', 'account_code', 170),
      ...debitCredit,
      ...common,
    ];
  }
  if ([DATA_TYPE.CUSTOMER, DATA_TYPE.SUPPLIER, DATA_TYPE.EMPLOYEE].includes(dataType)) {
    const objectLabel = dataType === DATA_TYPE.CUSTOMER ? 'khách hàng' : dataType === DATA_TYPE.SUPPLIER ? 'nhà cung cấp' : 'nhân viên';
    return [
      ...scopeColumns,
      textColumn('Số tài khoản', 'account_code', 150),
      textColumn(`Mã ${objectLabel}`, 'object_code', 170),
      textColumn(`Tên ${objectLabel}`, 'object_name', 280),
      ...debitCredit,
      ...(dataType !== DATA_TYPE.EMPLOYEE ? [textColumn('Theo dõi theo hóa đơn', 'track_by_invoice', 160)] : []),
      ...common,
    ];
  }
  if ([DATA_TYPE.CUSTOMER_INVOICE, DATA_TYPE.SUPPLIER_INVOICE].includes(dataType)) {
    return [
      ...scopeColumns,
      textColumn('Số tài khoản', 'account_code', 140),
      textColumn('Mã đối tượng', 'object_code', 150),
      textColumn('Tên đối tượng', 'object_name', 230),
      textColumn('Số chứng từ đầu kỳ', 'document_no', 180),
      textColumn('Ký hiệu hóa đơn', 'invoice_symbol', 150),
      textColumn('Số hóa đơn gốc', 'invoice_no', 170),
      { ...textColumn('Ngày hóa đơn', 'invoice_date', 140), render: dateText },
      { ...textColumn('Hạn thanh toán', 'due_date', 140), render: dateText },
      moneyColumn('Tổng tiền hóa đơn', 'invoice_total'),
      moneyColumn('Đã thu/trả trước', 'settled_amount'),
      ...debitCredit,
      ...common,
    ];
  }
  return [
    ...scopeColumns,
    textColumn('Mã hàng', 'product_code', 150),
    textColumn('Tên hàng', 'product_name', 280),
    textColumn('Nhóm VTHH', 'product_group', 130),
    textColumn('ĐVT', 'unit_name', 100),
    textColumn('Mã kho', 'stock_code', 140),
    moneyColumn('Số lượng', 'quantity', 6),
    moneyColumn('Giá trị tồn', 'inventory_value'),
    moneyColumn('Đơn giá vốn', 'unit_cost', 6),
    textColumn('Số lô', 'lot_number', 140),
    { ...textColumn('Hạn sử dụng', 'expiry_date', 140), render: dateText },
    textColumn('Mã vị trí', 'location_code', 130),
    textColumn('Số tài khoản kho', 'account_code', 150),
    textColumn('Ghi chú', 'note', 220),
  ];
};

export const editableFieldsFor = (dataType) => {
  if (dataType === DATA_TYPE.ACCOUNT) {
    return [
      ['account_code', 'Số tài khoản', 'text', true],
      ['debit', 'Dư Nợ', 'number'],
      ['credit', 'Dư Có', 'number'],
      ['currency_code', 'Loại tiền', 'text'],
      ['exchange_rate', 'Tỷ giá', 'number'],
      ['branch_code', 'Mã đơn vị/chi nhánh', 'text'],
      ['note', 'Ghi chú', 'textarea'],
    ];
  }
  if (dataType === DATA_TYPE.BANK) {
    return [
      ['bank_number', 'Số TK ngân hàng', 'text', true],
      ['account_code', 'Số tài khoản kế toán', 'text', true],
      ['debit', 'Dư Nợ', 'number'],
      ['credit', 'Dư Có', 'number'],
      ['currency_code', 'Loại tiền', 'text'],
      ['exchange_rate', 'Tỷ giá', 'number'],
      ['note', 'Ghi chú', 'textarea'],
    ];
  }
  if ([DATA_TYPE.CUSTOMER, DATA_TYPE.SUPPLIER, DATA_TYPE.EMPLOYEE].includes(dataType)) {
    return [
      ['account_code', 'Số tài khoản', 'text', true],
      ['object_code', 'Mã đối tượng', 'text', true],
      ['debit', 'Dư Nợ', 'number'],
      ['credit', 'Dư Có', 'number'],
      ...(dataType !== DATA_TYPE.EMPLOYEE ? [['track_by_invoice', 'Theo dõi theo hóa đơn', 'boolean']] : []),
      ['currency_code', 'Loại tiền', 'text'],
      ['exchange_rate', 'Tỷ giá', 'number'],
      ['note', 'Ghi chú', 'textarea'],
    ];
  }
  if ([DATA_TYPE.CUSTOMER_INVOICE, DATA_TYPE.SUPPLIER_INVOICE].includes(dataType)) {
    return [
      ['account_code', 'Số tài khoản', 'text', true],
      ['object_code', 'Mã đối tượng', 'text', true],
      ['document_no', 'Số chứng từ đầu kỳ', 'text'],
      ['invoice_symbol', 'Ký hiệu hóa đơn', 'text'],
      ['invoice_no', 'Số hóa đơn gốc', 'text', true],
      ['invoice_date', 'Ngày hóa đơn', 'date', true],
      ['due_date', 'Hạn thanh toán', 'date'],
      ['invoice_total', 'Tổng tiền hóa đơn', 'number'],
      ['settled_amount', 'Đã thu/trả trước', 'number'],
      ['debit', 'Dư Nợ', 'number'],
      ['credit', 'Dư Có', 'number'],
      ['currency_code', 'Loại tiền', 'text'],
      ['exchange_rate', 'Tỷ giá', 'number'],
      ['note', 'Diễn giải', 'textarea'],
    ];
  }
  return [
    ['product_code', 'Mã hàng', 'text', true],
    ['stock_code', 'Mã kho', 'text', true],
    ['quantity', 'Số lượng', 'number', true],
    ['unit_cost', 'Đơn giá vốn', 'number'],
    ['inventory_value', 'Giá trị tồn', 'number', true],
    ['lot_number', 'Số lô', 'text'],
    ['expiry_date', 'Hạn sử dụng', 'date'],
    ['location_code', 'Mã vị trí', 'text'],
    ['account_code', 'Số tài khoản kho', 'text'],
    ['branch_code', 'Mã đơn vị/chi nhánh', 'text'],
    ['note', 'Ghi chú', 'textarea'],
  ];
};
